import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { Office } from '@/types/office';

export const getOffices = async (email: string): Promise<ApiResult<Office[]>> => {
  const params = new URLSearchParams();
  params.append('email', email);
  const { status, result } = await callApi<Office[]>(
    `offices`,
    'GET',
    params,
    undefined,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
